import React, { useEffect, useMemo, useState } from 'react';
import useStudioExplain from '@home/hooks/useStudioExplain';
import { LIGHT_COLOR_ARR } from '@customComp/Chart/_config/_constant';
import MetricsCardRank from '@/pages/dashboard/components/MetricsCardRank';
import MetricsCardWrap from '@/pages/dashboard/components/MetricsCardWrap';
import Abnormal from '@home/components/Abnormal';
import { getCountryFlag } from '@home/_config/countries';
import './index.scss';
import classNames from 'classnames';
import { mapObjectValue } from '@home/pages/studio/utils';
import { jumpDetail, openWithParams } from '@/pages/dashboard/utils/utils';
import { DATA_TYPE_OBJECT } from '@home/utils/common';
import { extractParamsFromCarryFilter, getFilterConfig } from '../utils';
import { JumpType, navigate } from '@home/utils/utils';

const StudioMetricCardRankCountry = (props: any) => {
  const { config, className, style, filterConfig } = props || {};
  const {
    titleEn,
    titleCn,
    subtitleEn,
    subtitleCn,
    imgUrl,
    formatRule,
    valueDisplayMode,
    rainbowKey,
    explainEn,
    explainCn,
    link,
    sliceLength = 4,
    jumpParams = {},
    jumpType = JumpType.Window,
    filter,
    cardType,
    extraCarryParams={},
  } = config || {};
  const { data } = props?.data?.metricRankCountry || {};
  const { breakdown: countryList } = data || {};
  const [isNodata, setIsNodata] = useState(false);
  const { date_type: dataType, isSingle,start_time: startTime, end_time: endTime, payType, selectorList} = filter || {};
  const carryFilter = getFilterConfig(selectorList, filterConfig);

  useEffect(() => {
    if (!countryList || countryList.length === 0) {
      setIsNodata(true);
    } else {
      setIsNodata(false);
    }
  }, [countryList]);

  // 获取七彩石指标注释
  const { tipEn, tipCn } = useStudioExplain(rainbowKey, explainEn, explainCn);

  const rankData = countryList
    ?.filter((item: { name: string; }) => {
      // 过滤others
      const normalizedName = item?.name?.toLowerCase().replace(/\s+/g, '');
      return normalizedName !== 'others';
    })
    .map((item, index) => ({
      nameEn: item?.full_name,
      value: parseFloat(item?.value) || '',
      subValue: parseFloat(item?.share_of_all) || '',
      icon: getCountryFlag(item?.name),
      color: LIGHT_COLOR_ARR[index],
      valueDisplayMode,
    }))
    .sort((a: { value: number; }, b: { value: number; }) => b?.value - a?.value)
    .slice(0, sliceLength);

  // 筛选器继承参数
  const filterCarry = useMemo(() => {
    let baseParams;
      
    if (cardType === 'opinion') {
      baseParams = {
        start_time: startTime,
        end_time: endTime,
        date_type: dataType,
      };
    } else {
      baseParams = {
        start: startTime,
        end: endTime,
        timeType: DATA_TYPE_OBJECT[dataType],
        ...(payType ? { payment_type: payType } : {}),
      };
    }
      
    // 合并额外参数
    return { ...baseParams, ...extractParamsFromCarryFilter(extraCarryParams,carryFilter) };
  }, [filter, cardType, extraCarryParams, carryFilter]);

  // 卡片下钻
  const onClick = () => {
    if (link) {
      // 筛选器继承跳转
      if (jumpParams?.filterValue && isSingle && jumpParams?.isComplete && filter?.jumpTime) {
        jumpParams.filterValue.rangeTime = filter?.jumpTime;
      }

      navigate(link, { jumpType, windowParams: filterCarry });
      
      // 下钻逻辑
      // if (jumpParams?.filterValue) {
      //   jumpParams.filterValue = {
      //     ...mapObjectValue(jumpParams.filterValue,filter,),
      //     ...extractParamsFromCarryFilter(extraCarryParams,carryFilter)
      //   };
      // }
      // jumpDetail(link, jumpParams);
    }
  };

  return (
    <MetricsCardWrap
      titleCn={titleCn}
      titleEn={titleEn}
      subtitleEn={subtitleEn}
      subtitleCn={subtitleCn}
      className={classNames('dbh-studio-home-rank-card-country',className)}
      style={style}
      link={link ? onClick : null}
      tipsEn={tipEn}
      tipsCn={tipCn}
      imgUrl={imgUrl}
    >
      <Abnormal
        style={{ height: 180 }}
        component={
          <div className={`dbd-metrics-card-with-rank__right`}>
            <MetricsCardRank data={rankData} formatRule={formatRule} />
          </div>
        }
        isLoading={false}
        isError={false}
        isNoData={isNodata}
      />
    </MetricsCardWrap>
  );
};

export default StudioMetricCardRankCountry;
